import React, { Component } from "react";

class Pokemon extends Component {
  constructor() {
    super();
  }
  render() {
    return (
      <div>
        <div id='name'>
          Pokemon
        </div>
        <div className='pokemonNames' onscroll="myFunction()">
          {this.props.allPokemon.map(item => {
            return (
              <div>
                <p onClick={() => this.props.displayInfo(item.url) }>{item.name.toUpperCase()}</p>
              </div>

          );

        })}
        </div>
      </div>
    );
  }
}

export default Pokemon;





// WEBPACK FOOTER //
// ./src/components/Pokemon.js